<script>
  // @ts-check
  import Image from "../../atoms/Image.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * The featured image in the card
   * @type {import('../../types/shared.js').Image} Image
   */
  export let featuredImage;

  /**
   * The title of the component
   * @type {string}
   */
  export let title;

  /**
   * The optional description text of the component
   * @type {string}
   */
  export let description = null;

  /**
   * The call to action for the component
   * @type {string}
   */
  export let linkUrl;

  const hasFeatureImage = !!featuredImage?.src && !!featuredImage?.alt;
</script>

{#if linkUrl && title}
  <a
    {id}
    href={linkUrl}
    class="group relative flex w-full flex-col outline-2 outline-offset-[10px] outline-black focus-visible:outline-dashed"
    data-sveltekit-reload
  >
    {#if hasFeatureImage}
      <Image
        {...featuredImage}
        aspectRatioClasses="aspect-1/1"
        containerClass="overflow-hidden"
        elementClass="w-full h-auto transition-all duration-[400ms] ease-in-out group-hover:scale-[103%]"
      />
    {/if}
    <p class="heading-xs pt-6 md:pt-7 lg:pt-7.5 xl:pt-8">
      {title}
    </p>
    {#if description}
      <p class="body-sm pt-3 lg:pt-4">
        {description}
      </p>
    {/if}
  </a>
{/if}
